import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ComparisonArticle from "../pages/article/comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-przewodnik-2026",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/porownanie-spreadsheetow-2026",
    element: <ComparisonArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;